import { render, staticRenderFns } from "./InventoryConsumableCatalog.vue?vue&type=template&id=2f34fe8b"
import script from "./InventoryConsumableCatalog.vue?vue&type=script&lang=js"
export * from "./InventoryConsumableCatalog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports